import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';
import { TermsAndConditionsDialogComponent } from '../terms-and-conditions-dialog/terms-and-conditions-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  footerMsg: string;
  constructor(public dialog: MatDialog) { }


  ngOnInit() {
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(TermsAndConditionsDialogComponent, {
      disableClose: true,
      width: '90%',
      height: '80%',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts